<template>
  <RF-Dialog :id="cpntHashId"
    :cpntStatus='statusGeral'
    :cpntLargura='"520px"'

    :cpntAbaVet="abaVet"
    :cpntAbaValue="abaVal"
    :cpntAbaOnChange="proFormOnChangeAba"

    :cpntOnFecharDialog='proFormFechar'>
    <template slot='titulo'>
      <!-- SETA O ICONE DO CAMPO -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO DA ABA -->
      <template v-if="[ '', null, undefined, '0', 0 ].indexOf(cpntId) !== -1">Novo {{ proFormMontarNomeMudulo('primeiraMaiuscula') }}</template>
      <template v-else-if="[ '', null, undefined ].indexOf(dados) === -1">
        <template v-if="(typeof cpntId !== 'object')">
          <!-- SETA O TITULO DA ABA -->
          Edição do {{ proFormMontarNomeMudulo('primeiraMaiuscula') }} - {{ dados.codigo }}
          <br/>
          {{ dados.nome }} - {{ dados.id_cat_nome }} - {{ dados.id_mar_nome }}
        </template>
        <template v-else>Editar Vários</template>
      </template>
    </template>

    <template slot='botoes'>
      <div class="pro-form--acoes">
        <!-- SETA O BOTÃO COPIAR -->
        <App-Button :cpntIcone="'copiar'" @onClick="proFormCopiarCadastro" :title="'Copiar cadastro completo de outro ' + proFormMontarNomeMudulo('minusculo')"></App-Button>

        <!-- SETA O BOTÃO HISTORICO -->
        <template v-if="([ '', null, undefined, '0', 0 ].indexOf(cpntId) === -1 && typeof cpntId !== 'object')">
          <App-Button :cpntIcone="'historico'" @onClick="proFormHistoricoCadastro" title="Histórico do produto"></App-Button>
        </template>

        <!-- SETA O BOTÃO HISTORICO -->
        <template v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 20, 23 ], 'or', null, null, null, null, false) === true">
          <App-Button :cpntIcone="'fas fa-sliders-h'" @onClick="proFormNovaSitFiscal" title="Nova situação fiscal"></App-Button>
        </template>

        <!-- SETA O BOTÃO COPIAR -->
        <App-Button :cpntIcone="'fas fa-atom'" class="pro-form-acoes--simulador" @onClick="proFormSimuladorSitFiscal" :title="'Clique aqui para abrir o simulador de situação fiscal do ' + proFormMontarNomeMudulo('minusculo') + '.'"></App-Button>
      </div>
    </template>

    <template slot='conteudo'>
      <div class="pro-form">
        <App-Produto-Formulario-Principal :data-time="time" v-if="[ '', null, undefined ].indexOf(abaVet.principal) === -1 && abaVet.principal.carregado === true" v-show="abaVet.principal.mostrar === true" ref="principal"
        :cpntHashId="cpntHashId"
        :cpntId="cpntId"
        :cpntEditarVarios="editarVarios"
        :cpntDados="dados"
        :cpntQtdeInsumo="qtde_insumo"
        @PRODUTO_FORMULARIO_REMOVER_ERRO="proFormRemoverErroValidacaoAba"
        ></App-Produto-Formulario-Principal>

        <App-Produto-Formulario-Detalhes :data-time="time" v-if="[ '', null, undefined ].indexOf(abaVet.detalhe) === -1 && abaVet.detalhe.carregado === true" v-show="abaVet.detalhe.mostrar === true" ref="detalhe"
        :cpntHashId="cpntHashId"
        :cpntId="cpntId"
        :cpntEditarVarios="editarVarios"
        :cpntDados="dados"
        @PRODUTO_FORMULARIO_REMOVER_ERRO="proFormRemoverErroValidacaoAba"
        ></App-Produto-Formulario-Detalhes>

        <App-Produto-Formulario-Estoque :data-time="time" v-if="[ '', null, undefined ].indexOf(abaVet.estoque) === -1 && abaVet.estoque.carregado === true" v-show="abaVet.estoque.mostrar === true" ref="estoque"
        :cpntHashId="cpntHashId"
        :cpntId="cpntId"
        :cpntEditarVarios="editarVarios"
        :cpntDados="dados"
        :cpntValorAjusteNovo="ajuste_estoque"
        @PRODUTO_FORMULARIO_REMOVER_ERRO="proFormRemoverErroValidacaoAba"
        @PRODUTO_AJUSTE_ESTOQUE="proFormSetarDadosAjuste"
        @ATUALIZAR_INFORMACOES_EXTERNAS="() => { proFormAtualizarInfoExterna() }"
        @SALVAR_PRODUTO_ESTOQUE_AJUSTE="proFormOnSalvarAjusteEstoque"
        ></App-Produto-Formulario-Estoque>

        <App-Produto-Formulario-Insumos :data-time="time" v-if="[ '', null, undefined ].indexOf(abaVet.insumo) === -1 && abaVet.insumo.carregado === true" v-show="abaVet.insumo.mostrar === true" ref="insumo"
        :cpntHashId="cpntHashId"
        :cpntId="cpntId"
        :cpntEditarVarios="editarVarios"
        :cpntDados="dados"
        @SETAR_QTDE_INSUMO="proFormSetarQtdeInsumo"
        @PRODUTO_FORMULARIO_REMOVER_ERRO="proFormRemoverErroValidacaoAba"
        ></App-Produto-Formulario-Insumos>

        <App-Produto-Formulario-Imagens :data-time="time" v-if="[ '', null, undefined ].indexOf(abaVet.imagens) === -1 && abaVet.imagens.carregado === true" v-show="abaVet.imagens.mostrar === true" ref="imagens"
        :cpntHashId="cpntHashId"
        :cpntId="cpntId"
        :cpntEditarVarios="editarVarios"
        :cpntDados="dados"
        @PRODUTO_FORMULARIO_REMOVER_ERRO="proFormRemoverErroValidacaoAba"
        @ATUALIZAR_IMAGEM_PRODUTO="proFormAtualizarImagem"
        ></App-Produto-Formulario-Imagens>
      </div>

      <RF-Dialog v-if="[ '', null, undefined ].indexOf(copiar) === -1"
      :cpntLargura='(tela * 0.90).toString() + "px"'
      :cpntStatus="''"
      :cpntOnFecharDialog="() => { copiar = null }">
      <template slot='titulo'>
        <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
        <b>Copiar Cadastro {{ proFormMontarNomeMudulo('minusculo') }}</b>
      </template>

      <template slot='conteudo'>
        <App-Produto-Gerenciar :cpntSelecionar="copiar"></App-Produto-Gerenciar>
      </template>
      </RF-Dialog>

      <App-Produto-Sit-Fiscal-Formulario v-if="sit_fiscal !== null"
      :cpntId="sit_fiscal.id"
      :cpntNcms="sit_fiscal.ncms"
      :cpntProdutos="sit_fiscal.produtos"
      :cpntFecharFormulario="sit_fiscal.fechar"
      ></App-Produto-Sit-Fiscal-Formulario>
    </template>

    <template slot='rodape'>
      <div class="pro-form-botoes">
        <App-Button
          :cpntStatus='botoes.cancelar.status' 
          :cpntId='botoes.cancelar.id' 
          :cpntTexto='botoes.cancelar.texto' 
          :cpntClass='botoes.cancelar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.cancelar.tabIndex'
          @onClick='botoes.cancelar.onClick'
        ></App-Button>

        <App-Button
          :cpntStatus='botoes.salvar.status' 
          :cpntId='botoes.salvar.id' 
          :cpntTexto='botoes.salvar.texto' 
          :cpntClass='botoes.salvar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.salvar.tabIndex'
          @onClick='botoes.salvar.onClick'
        ></App-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.pro-form {
  min-height: 360px;
}

.pro-form-botoes {
  text-align: right;
}
  .pro-form-botoes > button {
    margin: 0px 4px;
  }
  .pro-form-botoes > button:last-child {
    margin-right: 0px;
  }

.pro-form--acoes > button:not(:first-child)  {
  margin-left: 5px;
}

</style>

<style>
  .pro-form-acoes--simulador {
    padding: 3px 10px !important;
  }
  .pro-form-acoes--simulador > span > span > svg {
    font-size: 16px;
    opacity: 0.85;
  }
</style>

<script>
  export default {
    props: {
      cpntHashId: {
        required: false,
        default: function () {
          // INICIA A VARIAVEL ID
          var hash = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          // PROCURA O NOME DO PRODUTO
          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            hash = 'pro-form-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(hash)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return hash
        }
      },
      cpntId: {
        required: true,
        type: [ String, Number, Array ],
        default: function () {
          return 0
        }
      },
      cpntDemanda: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntPDocTp: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntIdUf: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntIdCon: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return 0
        }
      },
      cpntNome: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntVetor: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'App-Produto-Formulario-Principal': () => import('@/components/produto/gerenciar/Formulario/Produto-Formulario-Principal.vue'),
      'App-Produto-Formulario-Detalhes': () => import('@/components/produto/gerenciar/Formulario/Produto-Formulario-Detalhes.vue'),
      'App-Produto-Formulario-Estoque': () => import('@/components/produto/gerenciar/Formulario/Produto-Formulario-Estoque.vue'),
      'App-Produto-Formulario-Insumos': () => import('@/components/produto/gerenciar/Formulario/Produto-Formulario-Insumos.vue'),
      'App-Produto-Formulario-Imagens': () => import('@/components/produto/gerenciar/Formulario/Produto-Formulario-Imagens.vue'),
      'App-Produto-Gerenciar': () => import('@/components/produto/gerenciar/Produto-Gerenciar.vue'),

      'App-Produto-Sit-Fiscal-Formulario': () => import('@/components/produto/sit-fiscal/Produto-Sit-Fiscal-Formulario.vue')

      // 'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba-2.vue'),
      // 'Produto-Formulario-Promocoes': () => import('@/components/produto/gerenciar/Formulario/Produto-Formulario-Promocoes.vue'),
      // 'Produto-Formulario-Avaliacoes': () => import('@/components/produto/gerenciar/Formulario/Produto-Formulario-Avaliacoes.vue'),
      // 'Produto-Formulario-Imagens': () => import('@/components/produto/gerenciar/Formulario/Produto-Formulario-Imagens.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        dados: {},
        abaVet: {},
        abaVal: '',
        tela: window.innerWidth,
        sit_fiscal: null,
        copiar: null,
        editarVarios: false,
        qtde_insumo: 0,
        ajuste_estoque: null,
        // ajuste_estoque: JSON.parse('{"id":"8","qtde_ajuste":"5.000","valor_unitario":"18.6720000000","valor_total":"93.3600000000","observacao":"QUANTIDADE INICIAL EM ESTOQUE","estoque_data_movimento_ptbr":"04\/04\/2023 \u00e0s 10:07:21","last_user":"6","last_user_usuario":"VcnetRFcontrole","last_at_ptbr":"04\/04\/2023 \u00e0s 10:07:21"}'),
        botoes: {
          cancelar: {
            status: '',
            tabIndex: 6010002,
            id: this.cpntHashId + '-botoes--cancelar',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: () => { this.proFormFechar(false) }
          },
          salvar: {
            status: '',
            tabIndex: 6010001,
            id: this.cpntHashId + '-botoes--salvar',
            texto: 'Salvar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.proFormSalvar() }
          }
        }
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.proFormSetaStatusGeral('carregando')

      // INICIA O CARREGAMENTO
      setTimeout(() => { this.proFormIniciar() }, 0)
    },
    methods: {
      proFormIniciar: function (callback = null) {
        // SETA O STATUS DA PAGINA
        this.proFormSetaStatusGeral('carregando')

        // INICIA A CRIAÇÃO DAS ABAS
        this.proFormCriarAbas()

        // INICIA O FLAG DE EDITAR VARIOS
        this.editarVarios = false

        // VERIFICA SE ESTÁ EDITANDO UM PRODUTO
        if (typeof this.cpntId !== 'object' && this.cpntId >= 1) {
          this.proFormBuscaDados(this.cpntId, (retorno) => {
            // SETA OS DADOS RECEBIDOS
            this.dados = retorno

            // DAR FOCUS NO CAMPO NOME
            this.proFormSetaFocusCampo('principal', 'nome')

            // SETA O STATUS DA PAGINA
            this.proFormSetaStatusGeral('')

            // SETA A QUANTIDADE DE INSUMOS
            this.proFormSetarQtdeInsumo(retorno.virtual_qtde_insumo)

            // EXECUTA O CALLBACK RECEBIDO
            if (callback !== null && typeof callback === 'function') {
              callback()
            }
            // setTimeout(() => { this.proFormFechar(true, '13956') }, 2000)
          })
        } else {
          // INICIA O FLAG DE EDITAR VARIOS
          if (typeof this.cpntId === 'object' && Array.isArray(this.cpntId) === true && this.cpntId.length >= 2) {
            this.editarVarios = true
          }

          // DAR FOCUS NO CAMPO NOME
          this.proFormSetaFocusCampo('principal', 'nome', this.cpntNome)

          // VERIFICA SE TEM CAMPO PARA SETAR
          if ([ '', null, undefined ].indexOf(this.cpntVetor) === -1 && Object.keys(this.cpntVetor).length >= 1) {
            for (var indexC in this.cpntVetor) {
              this.proFormSetaValorInicialCampo('principal', indexC, this.cpntVetor[indexC])
            }
          }

          // SETA O STATUS DA PAGINA
          if (this.editarVarios !== false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 12 ], null, [ 19 ], null, null, null, false) === true) {
            this.proFormBuscarQuantidadeInsumos(this.cpntId)
          } else {
            this.proFormSetaStatusGeral('')
          }

          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }

          // setTimeout(() => { this.proFormFechar(true, '13956') }, 2000)
        }
      },
      proFormBuscarQuantidadeInsumos: function (ids) {
        // MONTA O QUERY GET
        var queryGet = { type: 'list', return: 'countAll' }

        // SETA O WHERE DA PESQUISA
        queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_pro', o: 'in', v: ids.join() } ] }

        // COMUNICA COM A API
        this.$store.state.comunicaAPI('/produto/insumo/get/', 'GET', queryGet, (retorno) => {
          // SETA A QUANTIDADE DE INSUMOS
          this.proFormSetarQtdeInsumo(retorno.countAll)

          // SETA O STATUS DA PAGINA
          this.proFormSetaStatusGeral('')
        }, this.proFormSetaStatusGeral)
      },
      proFormSetarQtdeInsumo: function (qtde) {
        // SETA A QUANTIDADE RECEBIDA
        this.qtde_insumo = ([ '', null, undefined ].indexOf(qtde) !== -1 ? 0 : Number(qtde))

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormSetaValorInicialCampo: function (aba, campo, value = null, tentativa = 0) {
        if (tentativa <= 10) {
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[aba]) === -1 && [ '', null, undefined ].indexOf(this.$refs[aba].$refs[campo]) === -1) {
            // SETA O VALOR RECEBIDO
            this.$refs[aba].campos[campo].value = value

            // SETA A CLASSE DO CAMPO
            this.$refs[aba].campos[campo].class = 'rf-field-destaque-busca_api'

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.$refs[aba].time = new Date().getTime()
          } else {
            setTimeout(() => { this.proFormSetaValorInicialCampo(aba, campo, value, (tentativa + 1)) }, 100)
          }
        }
      },
      proFormSetaFocusCampo: function (aba, campo, value = null, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.proFormSetaFocusCampo(aba, campo, value, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[aba]) === -1 && [ '', null, undefined ].indexOf(this.$refs[aba].$refs[campo]) === -1) {
            // SETA O VALOR RECEBIDO
            if (value !== null) {
              this.$refs[aba].campos[campo].value = value
            }

            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[aba].$refs[campo]) === true ? this.$refs[aba].$refs[campo][0] : this.$refs[aba].$refs[campo]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              elemento.cpntRealizarFocus()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      proFormBuscaDados: function (id, callback) {
        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // SETA OS CAMPOS QUE DEVEM RETORNAR
        queryGet.field = {
          id: null,
          codigo: null,
          nome: null,
          ncm: null,
          cest: null,
          ind_escala: null,
          cnpj_fab: null,
          cod_fornecedor: null,
          c_benef: null,
          id_uni: null,
          id_uni_trib: null,
          qtde_trib: null,
          cod_barra_trib: null,
          id_tp_item: null,
          cod_barra: null,
          anp_cod: null,
          anp_desc: null,
          glp_p_glp: null,
          glp_p_gnn: null,
          glp_p_gni: null,
          glp_v_par: null,
          id_cat: { j: { nome: null } },
          id_mar: { j: { nome: null } },
          qtde_min: null,
          id_for: { j: { id: null, nome: null, empresa: null, cnpj_cpf: null } },
          valor_for_novo: { a: 'valor_for' },
          markup_por: null,
          valor_ven_markup_arredonda: null,
          valor_fixo_novo: { a: 'valor_fixo' },
          valor_ven_novo: { a: 'valor_ven' },
          obs: null,
          est_calc: null,
          updated_user: { j: { usuario: null } },
          updated_at: null,
          ins_fab_aut_na_venda: null,
          produto_acabado: null,
          insumo: null
        }

        // VERIFICA SE O CAMPO EXISTE
        if (this.$store.state.pcoAntigo === false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, null, null, null, null, false) === true) {
          queryGet.field.id_pco_status = { j: { nome: null } }
        }

        // VERIFICA SE TEM O PACOTE INSUMOS E UTILIZA A VERSÃO ANTIGA
        if (this.$store.state.insAntigo === true && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 12 ], null, null, null, null, null, false) === true) {
          queryGet.field.id_ins_rec = null
          queryGet.field.id_pro_est = null
        }

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { f: 'id', o: '=', v: id }
        
        // INICIA A VARIAVEL DO CAMPO VIRTUAL SE ELA NÃO EXISTIR
        queryGet.field_virtual = []

        // SETA O CAMPOS VIRTUAL QUE DEVE BUSCAR
        queryGet.field_virtual = queryGet.field_virtual.concat([ 'id_uni_desc', 'id_uni_trib_desc' ])

        // VERIFICA SE DEVE BUSCAR OS VALORES DE ESTOQUE
        if ([ '', null, undefined ].indexOf(this.abaVet.detalhe) === -1) {
          queryGet.field_virtual = queryGet.field_virtual.concat([ 'id_tp_item_desc' ])
        }

        // VERIFICA SE DEVE BUSCAR OS VALORES DE ESTOQUE
        if ([ '', null, undefined ].indexOf(this.abaVet.insumo) === -1) {
          queryGet.field_virtual = queryGet.field_virtual.concat([ 'qtde_insumo' ])
        }

        // COMUNICA COM A API
        this.$store.state.comunicaAPI('/produto/get', 'POST', queryGet, (retorno) => {
          if (retorno.data.length === 0) {
            // APRESENTA A MENSAGEM DE ERRO
            this.$store.state.msgWarn('WEB [409]: Erro ao localizar o ' + this.proFormMontarNomeMudulo('minusculo') + ' solicitado.', 'danger')

            // FECHA O FORMULARIO
            this.proFormFechar(false)
          } else {
            this.proFormBuscarArmArquivos(retorno.data[0], (vetor) => {
              // FORMATA OS VALORES RECEBIDOS
              vetor.valor_for  = Number(vetor.valor_for).toString()
              vetor.valor_fixo = Number(vetor.valor_fixo).toString()
              vetor.valor_ven  = Number(vetor.valor_ven).toString()
  
              // RETORNA OS VALORES PARA FUNÇÃO SOLICITANTE
              callback(vetor)
            })
          }
        }, this.proFormSetaStatusGeral)
      },
      proFormBuscarArmArquivos: function (vetor, callback) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 30 ], null, [ 54 ], null, [ 571 ], null, false) === true) {
          // INICIA O QUERYGET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1 }, field: { id: null, filename: null, ext: null, size_bytes_thumbnail: null, posicao: null, last_at: null }, order: {} }
  
          // SETA O WHERE
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_pro_imagem', o: '=', v: vetor.id } ] }
  
          // PEGA APENAS ARQUIVOS QUE NÃO SÃO INTERNOS
          queryGet.where.aAnd.push({ f: 'interno', o: '=', v: 'n' })
  
          // SETA A ORDENAÇÃO
          queryGet.order = { posicao: 'asc', last_at: 'asc' }
  
          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/arm-arquivo/get/', 'GET', queryGet, (retorno) => {
            // SETA A VARIAVEL
            vetor.arm_arquivo = null
  
            // SETA O VALOR RECEBIDO NO VETOR
            if (retorno.data.length >= 1) {
              vetor.arm_arquivo = retorno.data[0]
            }
  
            // EXECUTA O CALLBACK
            callback(vetor)
          }, this.proFormSetaStatusGeral)
        } else {
          callback(vetor)
        }
      },
      proFormTratarValorRecebido: function (valor) {
        // PEGA O VALOR UNITARIO RECEBIDO
        valor = Number(valor).toString()

        // FAZ A SEPARAÇÃO PARA VERIFICAÇÃO
        valor = valor.split('.')

        // FORMATA O VALOR RECEBIDO
        if (valor[valor.length -1].length >= 3) {
          valor = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', valor.join('.'))
        } else {
          // ADICIONA UM ZERO NO FINAL
          if (valor.length === 1) {
            valor.push('00')
          } else if (valor[(valor.length - 1)].length === 1) {
            valor[(valor.length - 1)] = (valor[(valor.length - 1)].toString() + '0')
          }

          // RETORNA O VALOR MONTADO
          valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.join(''))
        }

        // RETORNA O VALOR MONTADO
        return valor
      },
      proFormFechar: function (atualizar = false, id = null, dados = null) {
        if (atualizar === true && id !== null && dados === null) {
          this.proFormBuscaDados(id, (retorno) => { this.proFormFechar(atualizar, id, retorno) })
        } else {
          // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
          this.cpntFecharFormulario(atualizar, id, dados)

          // VERIFICA SE DEVE MUDAR A ROTA DO VUE
          if (this.$route.name === this.proFormMontarNomeMudulo('nome_route_form')) {
            this.$router.push({ name: this.proFormMontarNomeMudulo('nome_route_gere'), params: {} })
          }
        }
      },
      proFormCriarAbas: function (callback = null) {
        // LIMPA AS ABAS ENCONTRADAS
        this.abaVet = {
          principal: { chave: 'principal', nome: 'Principal', carregado: false, mostrar: false, alertas: { qtde: 0, mensagens: {}, mensagem: '' }, erros: { qtde: 0, mensagens: {}, mensagem: '' } },
          detalhe: { chave: 'detalhe', nome: 'Detalhes', carregado: false, mostrar: false, alertas: { qtde: 0, mensagens: {}, mensagem: '' }, erros: { qtde: 0, mensagens: {}, mensagem: '' } }
        }

        // VERIFICA SE TEM OS PACOTES PARA CONTROLE DE ESTOQUE
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5, 17 ], 'and', null, null, null, null, false) === true) {
          this.abaVet.estoque = { chave: 'estoque', nome: 'Estoque', carregado: false, mostrar: false, alertas: { qtde: 0, mensagens: {}, mensagem: '' }, erros: { qtde: 0, mensagens: {}, mensagem: '' } }
        }

        // VERIFICA SE TEM OS PACOTES PARA CONTROLE DE INSUMOS
        if (this.$store.state.insAntigo === false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 12 ], null, [ 19 ], null, [ 70 ], null, false) === true) {
          this.abaVet.insumo = { chave: 'insumo', nome: 'Insumos', carregado: false, mostrar: false, alertas: { qtde: 0, mensagens: {}, mensagem: '' }, erros: { qtde: 0, mensagens: {}, mensagem: '' } }
        }

        // SETA A ABA DE IMAGENS DO PRODUTO
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 30 ], null, [ 54 ], null, [ 571 ], null, false) === true) {
          this.abaVet.imagens = { chave: 'imagens', nome: 'Imagens', carregado: false, mostrar: false, alertas: { qtde: 0, mensagens: {}, mensagem: '' }, erros: { qtde: 0, mensagens: {}, mensagem: '' } }
        }

        // SETA A ABA INICAL
        this.proFormOnChangeAba(Object.keys(this.abaVet)[0])

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      proFormOnSalvarAjusteEstoque: function () {
        this.proFormSalvar((id) => {
          // REDIRENCIONA PARA TELA SOLICITADA
          if (this.$route.name !== this.proFormMontarNomeMudulo('nome_route_form')) {
            this.$emit('ALTERAR_ID_PRODUTO', id)
            this.proFormAtualizarInfoExterna()
          } else {
            this.$router.push({ name: this.proFormMontarNomeMudulo('nome_route_form'), params: { id: id } })
          }

          // INICIA O CARREGAMENTO
          setTimeout(() => { this.proFormIniciar(() => {
            // SETA A ABA QUE DEVE ABRIR
            this.proFormOnChangeAba('estoque')

            // CHAMA A FUNÇÃO PARA ABRIR TELA DE AJUSTE
            this.proFormSalvarAjusteEstoqueBuscarRefs(this.$refs, 'estoque', ($element1) => {
              // MANDA ABRIR A TELA DE AJUSTE DE ESTOQUE
              $element1.proFormEstoqueAjustarEstoque()

              // SETA OS VALORES RECEBIDOS
              this.$set(this.botoes.salvar, 'status', '')

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          }) }, 0)
        })
      },
      proFormOnChangeAba: function (aba) {
        if (aba === 'imagens' && this.cpntId === 0) {
          // SETA A ABA SELECIONADA
          this.abaVal = aba
  
          // SETA O STATUS DE CARREGAMENTO DA TELA
          this.abaVet[aba].carregado = false
  
          // SETA O STATUS DE CARREGAMENTO DA TELA
          this.abaVet[aba].mostrar = false
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // MANDA SALVAR OS DADOS
          setTimeout(() => {
            this.proFormSalvar((id) => {
              // REDIRENCIONA PARA TELA SOLICITADA
              if (this.$route.name !== this.proFormMontarNomeMudulo('nome_route_form')) {
                this.$emit('ALTERAR_ID_PRODUTO', id)
                this.proFormAtualizarInfoExterna()
              } else {
                this.$router.push({ name: this.proFormMontarNomeMudulo('nome_route_form'), params: { id: id } })
              }

              // INICIA O CARREGAMENTO
              setTimeout(() => { this.proFormIniciar(() => {
                // SETA A ABA QUE DEVE ABRIR
                this.proFormOnChangeAba('imagens')

                // SETA OS VALORES RECEBIDOS
                this.$set(this.botoes.salvar, 'status', '')

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
              }) }, 0)
            })
          }, 100)
        } else {
          // OCULTA TODAS AS ABAS
          for (var indexA in this.abaVet) {
            if (indexA !== aba) {
              this.abaVet[indexA].mostrar = false
            }
          }
  
          // SETA A ABA SELECIONADA
          this.abaVal = aba
  
          // SETA O STATUS DE CARREGAMENTO DA TELA
          this.abaVet[aba].carregado = true
  
          // SETA O STATUS DE CARREGAMENTO DA TELA
          this.abaVet[aba].mostrar = true
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      proFormMontarFormularioApi: function (aba, callback, _formData = {}) {
        if ([ '', null, undefined ].indexOf(this.$refs[aba]) !== -1) {
          callback(_formData)
        } else {
          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_MONTAR_FORMDATA_API(this.$refs[aba].campos).then((formData) => {
            // JUNTA OS DOIS VETORES RECEBIDOS
            _formData = Object.assign(_formData, formData)

            // RETORNA O VALOR MONTADO
            callback(_formData)
          })
        }
      },
      proFormSalvar: function (callback = null) {
        // SETA OS VALORES RECEBIDOS
        this.$set(this.botoes.salvar, 'status', 'carregando')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = {}

        // VERIFICA SE É UM NOVO PRODUTO
        if (this.cpntId === 0) {
          // SETA OS CAMPOS INICIAIS
          formData = {
            est_calc: '1',
            qtde_ini: '0.00',
            qtde_min: '0.00',
            id_tp_item: '0',

            // VERIFICA SE O PRODUTO É UM PRODUTO ACABADO
            produto_acabado: ([ 'insumo_form', 'insumo_gere' ].indexOf(this.$route.name) === -1 ? 's' : 'n'),

            // VERIFICA SE O PRODUTO É INSUMO
            insumo: ([ 'insumo_form', 'insumo_gere' ].indexOf(this.$route.name) !== -1 ? 's' : 'n')
          }

          // SETA O CAMPO DE INSUMO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 12 ], null, [ 19 ], null, null, null, false) === true) {
            formData.ins_fab_aut_na_venda = this.$store.state.configuracoes.produto.ins.cfg_ins_fab_aut_na_venda === true ? 's' : 'n'
          }
        }

        // FAZ A MONTAGEM DOS FORMULARIOS QUE SERÁ ENVIADO PARA API
        this.proFormMontarFormularioApi('principal', (formData) => {
          this.proFormMontarFormularioApi('detalhe', (formData) => {
            this.proFormMontarFormularioApi('estoque', (formData) => {
              this.proFormMontarFormularioApi('insumo', (formData) => {
                this.proFormSalvarCategoria(formData, (formData) => {
                  this.proFormSalvarMarca(formData, (formData) => { this.proFormSalvarCadastro(formData, null, callback) })
                })
              }, formData)
            }, formData)
          }, formData)
        }, formData)
      },
      proFormSalvarCadastro: function (formData, id = null, callback = null) {
        // SETA O ID QUE DEVE ATUALIZAR
        if ([ '', null, undefined ].indexOf(id) === -1) {
          formData.j_id = '[' + id + ']'
        } else if (this.cpntId !== 0) {
          formData.j_id = ([ 'string', 'number' ].indexOf(typeof this.cpntId) !== -1 ? '[' + this.cpntId + ']' : '[' + this.cpntId.join(',') + ']')
        }

        // SETA O METHOD QUE DEVE CHAMAR
        var method = [ '', null, undefined ].indexOf(formData.j_id) !== -1 ? 'POST' : 'PUT'

        // PEGA O VALOR DO CAMPO
        var usar_markup = this.$refs.principal.campos.usar_markup.value

        // TRATA O VALOR RECEBIDO
        usar_markup = typeof usar_markup !== 'object' ? usar_markup : usar_markup.id

        // VERIFICA SE TEM QUE MANDAR O CAMPO MARKUP
        switch (usar_markup) {
          case 'S':
            if (method === 'POST' || this.$refs.principal.campos.markup_por.value !== this.$refs.principal.campos.markup_por.valueIni) {
              formData.markup_por = this.$refs.principal.campos.markup_por.value
            }
            break
        
          case 'N':
          default:
            if (method === 'POST' || this.$refs.principal.campos.valor_ven.value !== this.$refs.principal.campos.valor_ven.valueIni) {
              formData.valor_fixo_novo = this.$refs.principal.campos.valor_ven.value
            }
            break
        }

        // VERIFICA SE TEM QUE FORMATAR O NUMERO
        if ([ '', null, undefined ].indexOf(formData.valor_for_novo) === -1 && isNaN(formData.valor_for_novo) === true) {
          // REMOVE O PONTO
          while (formData.valor_for_novo.indexOf('.') !== -1) {
            formData.valor_for_novo = formData.valor_for_novo.replace('.', '')
          }

          // CONVERTE A VIRGULA
          formData.valor_for_novo = formData.valor_for_novo.replace(',', '.')
        }

        // VERIFICA SE TEM QUE FORMATAR O NUMERO
        if ([ '', null, undefined ].indexOf(formData.markup_por) === -1 && isNaN(formData.markup_por) === true) {
          // REMOVE O PONTO
          while (formData.markup_por.indexOf('.') !== -1) {
            formData.markup_por = formData.markup_por.replace('.', '')
          }

          // CONVERTE A VIRGULA
          formData.markup_por = formData.markup_por.replace(',', '.')
        }

        // VERIFICA SE TEM QUE FORMATAR O NUMERO
        if ([ '', null, undefined ].indexOf(formData.valor_fixo_novo) === -1 && isNaN(formData.valor_fixo_novo) === true) {
          // REMOVE O PONTO
          while (formData.valor_fixo_novo.indexOf('.') !== -1) {
            formData.valor_fixo_novo = formData.valor_fixo_novo.replace('.', '')
          }

          // CONVERTE A VIRGULA
          formData.valor_fixo_novo = formData.valor_fixo_novo.replace(',', '.')
        }

        // REMOVE O CAMPO SE NÃO TIVER UM VALOR VALIDO
        if ([ '', null, undefined ].indexOf(formData.markup_por) !== -1) {
          delete formData.markup_por
        }

        // REMOVE O CAMPO SE NÃO TIVER UM VALOR VALIDO
        if ([ '', null, undefined ].indexOf(formData.j_insumo) !== -1 || this.cpntEditarVarios === true) {
          delete formData.j_insumo
        }

        // REMOVE AS CHAVES QUE NÃO DEVE INFORMAR SE O CALCULO DO ESTOQUE ESTIVER DESTAVIDADO
        if (formData.est_calc === '0') {
          delete formData.qtde_min
          delete formData.qtde_ini
        }

        // CONVERTE O VALOR QUE ESTÁ SENDO ENVIADO PARA API
        if ([ '', null, undefined ].indexOf(formData.ins_fab_aut_na_venda) === -1) {
          formData.ins_fab_aut_na_venda = [ '1', 1, 's', 'S', true, 'true' ].indexOf(formData.ins_fab_aut_na_venda) !== -1 ? 's' : 'n'
        }

        // VERIFICA SE TEM QUE INFORMAR O CAMPO DE INSUMO
        if ([ '', null, undefined ].indexOf(this.$refs.insumo) === -1 && ((this.$refs.insumo.campos.produto_acabado.value !== this.$refs.insumo.campos.produto_acabado.valueIni) || (this.$refs.insumo.campos.insumo.value !== this.$refs.insumo.campos.insumo.valueIni))) {
          formData.produto_acabado = typeof this.$refs.insumo.campos.produto_acabado.value === 'string' ? this.$refs.insumo.campos.produto_acabado.value : this.$refs.insumo.campos.produto_acabado.value.id
          formData.insumo = typeof this.$refs.insumo.campos.insumo.value === 'string' ? this.$refs.insumo.campos.insumo.value : this.$refs.insumo.campos.insumo.value.id
        }

        // VERIFICA SE TEM QUE EXCLUIR O VALOR DO FORNECEDOR
        if ([ '', null, undefined ].indexOf(this.qtde_insumo) === -1 && this.qtde_insumo > 0) {
          delete formData.valor_for_novo
        }

        // VERIFICA SE TEM QUE FORMATAR O NUMERO
        if ([ '', null, undefined ].indexOf(formData.qtde_trib) === -1 && isNaN(formData.qtde_trib) === true) {
          // REMOVE O PONTO
          while (formData.qtde_trib.indexOf('.') !== -1) {
            formData.qtde_trib = formData.qtde_trib.replace('.', '')
          }

          // CONVERTE A VIRGULA
          formData.qtde_trib = formData.qtde_trib.replace(',', '.')
        }

        // REMOVE O VALOR NÃO SELECIONADO
        if (formData.id_pco_status === '-1') {
          delete formData.id_pco_status
        }

        // FAZ A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI('/produto', method, formData, (retorno) => {
          // PEGA O VALOR RECEBIDO
          retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : Object.assign(retorno, { code: '200' })

          // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
          if (retorno.code !== '200') {
            this.proFormTratarValidacao(retorno.message, retorno.code)
          // } else if (method === 'POST' && [ '', null, undefined ].indexOf(formData.j_insumo) === -1) {
          //   this.proFormSalvarCadastro({ j_insumo: formData.j_insumo }, retorno.ref.id)
          } else {
            // PEGA O ID QUE DEVE ENVIAR
            var id = ([ '', null, undefined ].indexOf(retorno.ref) === -1 && [ '', null, undefined ].indexOf(retorno.ref.id) === -1 ? retorno.ref.id : ([ '', null, undefined ].indexOf(id) === -1 ? id : this.cpntId))


            // SETA A FUNÇÃO DE FINALIZAÇÃO
            var finalizar = () => {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
              
              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              if (callback !== null && typeof callback === 'function') {
                callback(id)
                this.proFormAtualizarInfoExterna()
              } else {
                this.proFormFechar(true, id)
              }
            }

            // INICIA O CARREGAMENTO
            if ([ '', null, undefined ].indexOf(this.ajuste_estoque) === -1) {
              // ALTERA O ID DO PRODUTO
              if (id.toString() !== this.cpntId.toString()) {
                if (this.$route.name !== this.proFormMontarNomeMudulo('nome_route_form')) {
                  this.$emit('ALTERAR_ID_PRODUTO', id)
                  this.proFormAtualizarInfoExterna()
                } else {
                  this.$router.push({ name: this.proFormMontarNomeMudulo('nome_route_form'), params: { id: id } })
                }
              }

              // VERIFICA PARA SALVAR O FORMULARIO
              setTimeout(() => { this.proFormSalvarAjusteEstoque(id, finalizar) }, 0)
            } else {
              finalizar()
            }
          }
        }, this.proFormSetaStatusGeral, (apiValid, apiStatus) => { this.proFormTratarValidacao(apiValid, apiStatus) })
      },
      proFormSalvarCategoria: function (_formData, callback) {
        if (_formData.id_cat !== '__NOVO_OPTION__') {
          callback(_formData)
        } else {
          // PEGA O VALOR DIGITADO PELO CLIENTE
          var option = this.$refs.principal.campos.id_cat.value

          // INICIA AS VARIAVEIS
          var formData = { nome: option._text }

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/produto/categoria', 'POST', formData, (retorno) => {
            // LIMPA OS OPTIONS PARA BUSCAR NOVAMENTE AO ABRIR O CAMPO
            this.$refs.principal.campos.id_cat.options = []
            this.$refs.principal.campos.id_cat.value = { id: retorno.ref.id, nome: option._text }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.$refs.principal.time = new Date().getTime()
            this.time = new Date().getTime()

            // SETA O ID ATUALIZADO DO MODELO
            _formData.id_cat = retorno.ref.id

            // FINALIZA O PROCESSO E RETORNA A FUNÇÃO
            callback(_formData)
          }, this.proFormSetaStatusGeral, (apiValid, apiStatus) => {
            // VERIFICA SE DEVE ALTERAR OS DADOS DO CAMPO QUE ESTÁ SENDO SALVO
            if ([ '', null, undefined ].indexOf(apiValid.nome) === -1 || [ '', null, undefined ].indexOf(apiValid.geralWeb) === -1) {
              // ADICIONA O NOME DO CAMPO CORRETO
              apiValid.id_cat = [ '', null, undefined ].indexOf(apiValid.nome) === -1 ? apiValid.nome : apiValid.geralWeb

              // REMOVE O CAMPO NOME DO VETOR
              delete apiValid.nome
              delete apiValid.geralWeb
            }

            // CHAMA A FUNÇÃO PARA APRESENTAR A MESNAGEM DE ERRO RECEBIDA
            this.proFormTratarValidacao(apiValid, apiStatus)
          })
        }
      },
      proFormSalvarMarca: function (_formData, callback) {
        if (_formData.id_mar !== '__NOVO_OPTION__') {
          callback(_formData)
        } else {
          // PEGA O VALOR DIGITADO PELO CLIENTE
          var option = this.$refs.principal.campos.id_mar.value

          // INICIA AS VARIAVEIS
          var formData = { nome: option._text }

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/produto/marca', 'POST', formData, (retorno) => {
            // LIMPA OS OPTIONS PARA BUSCAR NOVAMENTE AO ABRIR O CAMPO
            this.$refs.principal.campos.id_mar.options = []
            this.$refs.principal.campos.id_mar.value = { id: retorno.ref.id, nome: option._text }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.$refs.principal.time = new Date().getTime()
            this.time = new Date().getTime()

            // SETA O ID ATUALIZADO DO MODELO
            _formData.id_mar = retorno.ref.id

            // FINALIZA O PROCESSO E RETORNA A FUNÇÃO
            callback(_formData)
          }, this.proFormSetaStatusGeral, (apiValid, apiStatus) => {
            // VERIFICA SE DEVE ALTERAR OS DADOS DO CAMPO QUE ESTÁ SENDO SALVO
            if ([ '', null, undefined ].indexOf(apiValid.nome) === -1 || [ '', null, undefined ].indexOf(apiValid.geralWeb) === -1) {
              // ADICIONA O NOME DO CAMPO CORRETO
              apiValid.id_mar = [ '', null, undefined ].indexOf(apiValid.nome) === -1 ? apiValid.nome : apiValid.geralWeb

              // REMOVE O CAMPO NOME DO VETOR
              delete apiValid.nome
              delete apiValid.geralWeb
            }

            // CHAMA A FUNÇÃO PARA APRESENTAR A MESNAGEM DE ERRO RECEBIDA
            this.proFormTratarValidacao(apiValid, apiStatus)
          })
        }
      },
      proFormTratarValidacao: function (apiValid, apiStatus = 400, indexA = 0, iniciado = false, focus = '') {
        // PEGA O NOME DAS ABAS EXISTENTES NO PRODUTO
        var abas = Object.keys(this.abaVet)

        // PEGA O NOME DA ABA QUE ESTÁ SENDO TRABALHADO
        var aba = abas[indexA]

        // CARREGA TODAS AS ABAS PARA PODER APRESENTAR AS MENSAGENS
        if (indexA === 0 && iniciado === false) {
          // CARREGA TODAS AS ABAS PARA PODER APRESENTAR AS MENSAGENS
          for (var index in this.abaVet) {
            if (index !== this.abaVal) {
              this.abaVet[index].carregado = true
              this.abaVet[index].mostrar = false
            }
          }

          // AGUARDA O CARREGAMENTO DAS ABAS
          setTimeout(() => { this.proFormTratarValidacao(apiValid, apiStatus, indexA, true, focus) }, 500)
        } else {
          // VERIFICA SE É O FINAL DO VETOR
          var final = [ '', null, undefined ].indexOf(abas[(indexA + 1)]) !== -1
  
          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API
  
          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.$refs[aba].campos, this.$refs[aba], final, (faltantes, vetorErro, _focus) => {
            // SETA O FOCUS NA ABA SOLICITADA
            if (_focus !== focus) {
              this.proFormOnChangeAba(aba)
            }

            // SETA OS ERROS ENCONTRADOS NAS ABAS
            if (Object.keys(vetorErro).length >= 1) {
              this.abaVet[aba].erros = { qtde: Object.keys(vetorErro).length, mensagens: vetorErro, mensagem: Object.values(vetorErro).join('\n') }
            }
    
            // VERIFICA SE DEVE SETAR OS ERROS NA PROXIMA ABA
            if (Object.keys(faltantes).length >= 1) {
              this.proFormTratarValidacao(faltantes, apiStatus, (indexA + 1), iniciado, _focus)
            } else {
              // SETA OS VALORES RECEBIDOS
              this.$set(this.botoes.salvar, 'status', '')
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          }, false, focus)
        }
      },
      proFormRemoverErroValidacaoAba: function (chave) {
        // PEGA O NOME DA ABA ATUAL ABERTA
        var aba = this.abaVal

        // REMOVE O ERRO SOLICITADO
        delete this.abaVet[aba].erros.mensagens[chave]

        // ATUALIZA A QUANTIDADE DE ERROS
        this.abaVet[aba].erros.qtde = Object.keys(this.abaVet[aba].erros.mensagens).length

        // ATUALIZA A QUANTIDADE DE ERROS
        this.abaVet[aba].erros.mensagem = Object.values(this.abaVet[aba].erros.mensagens).join('\n')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormHistoricoCadastro: function () {
      //   // INICIA O LINK QUE SERÁ BUSCADO
      //   var link = process.env.VUE_APP_URL_CS + '/app/produtos/produtos_his.php?cts=' + this.$store.state.token.cts

      //   // SETA O ID DO PRODUTO
      //   link += '&p=' + this.cpntId

      //   // SETA A CATEGORIA DO PRODUTO
      //   link += '&c=' + this.dados.id_cat

      //   // ABRE O LINK SOLICITADO
      //   this.$store.state.OPEN_PAGE_CS(link, '_blank')
      // },
        // CARREGA OS PARAMETROS
        var params = { name: 'produto_historico_busca', params: { cts: this.$store.state.token.cts, cpntFiltros: window.btoa(JSON.stringify({ pro: [ this.cpntId.toString() ] })) } }

        // ABRE O RECIBO DA DEMANDA SOLICITADO
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve(params).href, '_blank', {}, false)
      },
      proFormNovaSitFiscal: function () {
        // INICIA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { id: 0 }

        // SETA O VALOR DA NCM PREENCHIDA
        if (this.cpntId === 0) {
          params.ncms = [ this.$refs.principal.campos.ncm.value ]
        } else {
          params.produtos = typeof this.cpntId === 'object' ? this.cpntId : [ this.cpntId ]
        }

        // SETA A FUNÇÃO PARA FECHAR
        params.fechar = () => {
          // MANDA FECHAR A TELA
          this.sit_fiscal = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // SETA OS DADOS QUE DEVE EDITAR NA SITUAÇÃO FSICAL
        this.sit_fiscal = params

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormCopiarCadastro: function () {
        this.copiar = (dados) => {
          this.proFormBuscaDados(dados.id, (retorno) => {
            this.proFormBuscaQtdeNomeIgual(retorno, (retorno) => {
              // LIMPA OS CAMPOS QUE TEM QUE SER DIFERENTE PARA CADA PRODUTO
              retorno.codigo = ''
              // retorno.nome = ''
              retorno.cod_barra = ''
  
              // CARREGA TODAS AS ABAS
              for (var indexA in this.abaVet) {
                // VERIFICA SE DEVE CARREGAR A ABA
                if (indexA !== this.abaVal) {
                  this.abaVet[indexA].carregado = true
                  this.abaVet[indexA].mostrar = false
                }
  
                // MANDA ATUALIZAR AS ABAS COM O NOVO VALOR
                this.proFormCopiarCadastroSetarValores(indexA, retorno)
              }
  
              // LIMPA A VARIAVEL PARA FECHAR ATELA
              this.copiar = null
            })
          })
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormCopiarCadastroSetarValores: function (indexA, dados) {
        setTimeout(() => {
          // INICIA A VARIAVEL
          var chave = ''
          var chaves = []

          // VERIFICA QUAL ABA DEVE ATUALIZAR
          switch (indexA) {
            case 'principal':
              // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
              chaves = Object.keys(this.$refs[indexA].campos)

              // RODA O VETOR DOS CAMPOS
              for (var index1 in chaves) {
                // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
                chave = chaves[index1]

                // SETA OS VALORES DO CAMPO
                this.$refs[indexA].proFormPrincipalSetarValorCampo(chave, dados)

                // SETA A CLASSE DO CAMPO
                if (JSON.stringify(this.$refs[indexA].campos[chave].value) !== JSON.stringify(this.$refs[indexA].campos[chave].valueIni)) {
                  this.$refs[indexA].campos[chave].class = 'rf-field-destaque-busca_api'
                }
              }
              break

            case 'detalhe':
              // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
              chaves = Object.keys(this.$refs[indexA].campos)

              // RODA O VETOR DOS CAMPOS
              for (var index2 in chaves) {
                // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
                chave = chaves[index2]

                // SETA OS VALORES DO CAMPO
                this.$refs[indexA].proFormDetalheSetarValorCampo(chave, dados)

                // SETA A CLASSE DO CAMPO
                if (JSON.stringify(this.$refs[indexA].campos[chave].value) !== JSON.stringify(this.$refs[indexA].campos[chave].valueIni)) {
                  this.$refs[indexA].campos[chave].class = 'rf-field-destaque-busca_api'
                }
              }
              break

            case 'estoque':
              // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
              chaves = [ 'est_calc', 'qtde_min' ]

              // RODA O VETOR DOS CAMPOS
              for (var index3 in chaves) {
                // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
                chave = chaves[index3]

                // SETA OS VALORES DO CAMPO
                this.$refs[indexA].proFormEstoqueSetarValorCampo(chave, dados)

                // SETA A CLASSE DO CAMPO
                if (JSON.stringify(this.$refs[indexA].campos[chave].value) !== JSON.stringify(this.$refs[indexA].campos[chave].valueIni)) {
                  this.$refs[indexA].campos[chave].class = 'rf-field-destaque-busca_api'
                }
              }
              break

            case 'insumo':
              this.$refs[indexA].proFormInsumoBuscarLinhas(chave, dados)
              break
          }
        }, 500)
      },
      proFormBuscaQtdeNomeIgual: function (dados, callback = null, tentativa = 1) {
        // ADICIONA UMA STRING NO FINAL PARA DIFERENCIAR
        var nome = dados.nome + ' (' + tentativa + ')'

        // VERIFICA SE ESTOUROU A QUANTIDADE DE VEZES
        if (tentativa >= 10) {
          // LIMPA OS DADOS DO CAMPO
          dados.nome = dados.nome + ' ()'
          
          // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
          if (callback !== null && typeof callback === 'function') {
            callback(dados)
          }
        } else {
          // SETA O QUERY GET NA API
          var queryGet = { type: 'list', field: { id: null }, limit: { row: 0, qty: 1000 } }

          // SETA O WHERE QUE SERÁ REALIZADO
          queryGet.where = { aAnd: [ { f: 'nome', o: '=', v: nome }, { f: 'status', o: '=', v: '1' } ] }

          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/produto/get', 'POST', queryGet, (apiSuccess) => {
            if (Number(apiSuccess.countAll) >= 1) {
              this.proFormBuscaQtdeNomeIgual(dados, callback, (tentativa + 1))
            } else {
              // LIMPA OS DADOS DO CAMPO
              dados.nome = dados.nome + ' (' + tentativa + ')'
              
              // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
              if (callback !== null && typeof callback === 'function') {
                callback(dados)
              }
            }
          }, this.proFormSetaStatusGeral)
        }
      },
      proFormSimuladorSitFiscal: function () {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { tipo: 'SIMULADOR_SIT_FISCAL' }

        // SETA A NCM DO PRODUTO
        params.ncm = this.$refs.principal.campos.ncm.value

        // SETA O ID DO PRODUTO
        params.id_pro = typeof this.cpntId !== 'object' && this.cpntId >= 1 ? this.cpntId : ''

        // SETA A NCM RECEBIDA
        params.demanda = this.cpntDemanda

        // SETA O ESTADO QUE DEVE SER UTILIZADO
        params.p_doc_tp = this.cpntPDocTp

        // SETA O CONTATO QUE DEVE SER UTILIZADO
        params.id_con = this.cpntIdCon

        // SETA O ESTADO QUE DEVE SER UTILIZADO
        params.id_uf = this.cpntIdUf

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      proFormAtualizarImagem: function (vetor) {
        // ATUALIZA OS DADOS DA IMAGEM
        this.dados.arm_arquivo = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormMontarNomeMudulo: function (tipo) {
        switch (this.$route.name + '__' + tipo) {
          case 'prod_gere__nome_route_form':
          case 'prod_form__nome_route_form':
            return 'prod_form'

          case 'prod_gere__nome_route_gere':
          case 'prod_form__nome_route_gere':
            return 'prod_gere'

          case 'compra_numero__minusculo':
          case 'dev_fornecedor_numero__minusculo':
          case 'venda_numero__minusculo':
          case 'dev_cliente_numero__minusculo':
          case 'prod_gere__minusculo':
          case 'prod_form__minusculo':
            return 'produto'

          case 'compra_numero__primeiraMaiuscula':
          case 'dev_fornecedor_numero__primeiraMaiuscula':
          case 'venda_numero__primeiraMaiuscula':
          case 'dev_cliente_numero__primeiraMaiuscula':
          case 'prod_gere__primeiraMaiuscula':
          case 'prod_form__primeiraMaiuscula':
            return 'Produto'

          case 'insumo_gere__nome_route_form':
          case 'insumo_form__nome_route_form':
            return 'insumo_form'

          case 'insumo_gere__nome_route_gere':
          case 'insumo_form__nome_route_gere':
            return 'insumo_gere'

          case 'insumo_gere__minusculo':
          case 'insumo_form__minusculo':
            return 'insumo'

          case 'insumo_gere__primeiraMaiuscula':
          case 'insumo_form__primeiraMaiuscula':
            return 'Insumo'
        }
      },
      proFormSetarDadosAjuste: function (formData) {
        // SETA OS DADOS RECEBIDOS
        this.ajuste_estoque = formData

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormSalvarAjusteEstoque: function (id, callback) {
        if ([ '', null, undefined ].indexOf(this.ajuste_estoque) === -1) {
          // PEGA O FORMULARIO QUE DEVE ENVIAR
          var formData = JSON.parse(JSON.stringify(this.ajuste_estoque))
  
          // SETA O METHOD QUE DEVE CHAMAR
          var method = [ '', null, undefined, '0', 0 ].indexOf(formData.id) !== -1 ? 'POST' : 'PUT'
  
          // VERIFICA SE TEM QUE ADICIONAR O ID
          if (method !== 'PUT') {
            formData.id_pro = id
          }
  
          // CONVERTE EM LOTE
          formData = { lot: [ formData ] }
  
          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/produto/estoque/ajuste', method, formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : Object.assign(retorno, { code: '200' })
  
            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.proFormSalvarAjusteEstoqueValidacao(retorno.message, retorno.code)
            } else {
              callback(id)
            }
          }, this.proFormSetaStatusGeral, (apiValid, apiStatus) => { this.proFormSalvarAjusteEstoqueValidacao(apiValid, apiStatus) })
        } else {
          callback()
        }
      },
      proFormSalvarAjusteEstoqueValidacao: function (apiValid, apiStatus) {
        // ABREA A ABA DE ESTOQUE
        this.proFormOnChangeAba('estoque')

        // SETA OS ERROS ENCONTRADOS NAS ABAS
        this.abaVet.estoque.erros = { qtde: Object.keys(apiValid).length, mensagens: apiValid, mensagem: Object.values(apiValid).join('\n') }
         
        // SETA OS VALORES RECEBIDOS
        this.$set(this.botoes.salvar, 'status', '')
    
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        this.proFormSalvarAjusteEstoqueBuscarRefs(this.$refs, 'estoque', ($element1) => {
          // MANDA ABRIR A TELA DE AJUSTE DE ESTOQUE
          $element1.proFormEstoqueAjustarEstoque()

          // BUSCA O PROXIMO ELEMENTO
          this.proFormSalvarAjusteEstoqueBuscarRefs($element1.$refs, 'estoque_ajuste', ($element2) => {
            setTimeout(() => {
              // SETA O ID QUE DEVE REALIZAR O PROCESSO DE EDITAR
              $element2.checkbox.push('0')
    
              // MANDA EDITAR O CADASTRO
              $element2.proFormEstAjusteEditarRegistro()
              
              // BUSCA O PROXIMO ELEMENTO
              this.proFormSalvarAjusteEstoqueBuscarRefs($element2.$refs, 'formulario', ($element3) => {
                $element3.proFormEstAjusteNovoTratarValidacao(apiValid, apiStatus)
              })
            }, 600)
          })
        })
        
      },
      proFormSalvarAjusteEstoqueBuscarRefs: function ($element, chave, callback, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.proFormSalvarAjusteEstoqueBuscarRefs($element, chave, callback, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf($element[chave]) === -1) {
            setTimeout(() => { callback($element[chave]) }, 100)
          } else {
            reiniciar()
          }
        }
      },
      proFormAtualizarInfoExterna: function () {
        this.$emit('ATUALIZAR_INFORMACOES_EXTERNAS')
      }
    }
  }
</script>
